module.exports = __webpack_public_path__ + "static/media/subtitle_language.9908e482.svg";